import { useState, useEffect } from 'react';

/**
 * Custom hook to track scroll position with throttling for performance
 * @param {number} threshold - Scroll threshold to trigger state change
 * @returns {Object} - { scrollY, isScrolled }
 */
const useScrollPosition = (threshold = 100) => {
  const [scrollY, setScrollY] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    let ticking = false;

    const updateScrollPosition = () => {
      const currentScrollY = window.scrollY;
      setScrollY(currentScrollY);
      setIsScrolled(currentScrollY > threshold);
      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(updateScrollPosition);
        ticking = true;
      }
    };

    // Set initial scroll position
    updateScrollPosition();

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Cleanup on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [threshold]);

  return { scrollY, isScrolled };
};

export default useScrollPosition;